exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018, 2020\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.starting-points-page .fieldInput {\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  border-bottom: solid 2px;\n  border-bottom-color: #8d8d8d;\n  border-bottom-color: hsla(var(--ui-04-h, 0), var(--ui-04-s, 0%), var(--ui-04-l, 55.29412%), 1);\n}\n\n.starting-points-page .inputClear {\n  position: absolute;\n  right: 0;\n  transform: translateY(-50%);\n  top: 50%;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader??ref--2-2!./node_modules/resolve-url-loader!./node_modules/sass-loader/lib/loader.js??ref--2-4!./src/js/components/startingPoints/FieldInput.scss
// module id = 379
// module chunks = 0